import { render, staticRenderFns } from "./ProviderImportModal.vue?vue&type=template&id=3f65a886&scoped=true"
import script from "./ProviderImportModal.vue?vue&type=script&lang=js"
export * from "./ProviderImportModal.vue?vue&type=script&lang=js"
import style0 from "./ProviderImportModal.vue?vue&type=style&index=0&id=3f65a886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f65a886",
  null
  
)

export default component.exports